module.exports = __webpack_public_path__ + "media/src/images/brand_logo-1ccf3800464c339aa2562d2936b651f8.svg";